import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import _ from 'lodash';
import GMap, { Marker, InfoWindow } from './components/GMap';
import HostTeaserSmall from '../../components/hostTeaser/HostTeaserSmall';
import markerIcon from './markerIcon.svg';
import { googleApiKey } from './configuration';
import store from '../../config/redux/store';

export class MapContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeMarker: null,
      selectedPlace: null,
      showingInfoWindow: false,
      isMapCreated: false,
    };
    this.onMapCreated = this.onMapCreated.bind(this);
    this.onMarkerClick = this.onMarkerClick.bind(this);
    this.onMapClick = this.onMapClick.bind(this);
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      !_.isEqual(nextState, this.state) ||
      nextProps.markers.length !== this.props.markers.length ||
      !_.isEqualWith(nextProps.markers, this.props.markers, (nextMarkers, currMarkers) =>
        _.every(_.range(nextMarkers.length), (i) => nextMarkers[i].id === currMarkers[i].id),
      )
    );
  }

  onMapCreated(map) {
    this.setState({
      isMapCreated: true,
    });

    this.map = map;
  }

  onMarkerClick(props, marker) {
    this.setState({
      activeMarker: marker,
      selectedPlace: props.host,
      showingInfoWindow: true,
    });
  }

  onMapClick() {
    if (this.state.showingInfoWindow) {
      this.setState({
        activeMarker: null,
        selectedPlace: null,
        showingInfoWindow: false,
      });
    }
  }

  renderMarkers() {
    if (this.state.isMapCreated) {
      return this.props.markers.map((marker) => (
        <Marker
          key={`marker_${marker.id}`}
          name={`marker_${marker.id}`}
          position={{ lat: marker.latitude, lng: marker.longitude }}
          icon={markerIcon}
          onClick={this.onMarkerClick}
          host={marker}
          map={this.map}
        />
      ));
    }
    return null;
  }

  renderInfoWindow() {
    if (this.state.selectedPlace) {
      return (
        <InfoWindow
          marker={this.state.activeMarker}
          visible={this.state.showingInfoWindow}
          map={this.map}
        >
          <Provider store={store}>
            <HostTeaserSmall
              {...this.state.selectedPlace}
              showImageNotSlider
              useLinkOutsideRouter
              renderPriceAlternatives={false}
            />
          </Provider>
        </InfoWindow>
      );
    }
    return null;
  }

  render() {
    const mapProps = _.pick(this.props, [
      'params',
      'zoom',
      'className',
      'style',
      'containerStyle',
      'visible',
      'mapType',
      'maxZoom',
      'clickableIcons',
      'disableDefaultUI',
      'zoomControl',
      'mapTypeControl',
      'scaleControl',
      'streetViewControl',
      'panControl',
      'rotateControl',
      'scrollwheel',
      'draggable',
      'keyboardShortcuts',
      'disableDoubleClickZoom',
      'noClear',
      'styles',
      'centerAroundCurrentLocation',
      'onMapCreated',
    ]);
    return (
      <GMap
        {...mapProps}
        className="map-container"
        google={window.google}
        disableDefaultUI
        params={{ v: '3', apiKey: googleApiKey }}
        onClick={this.onMapClick}
        onMapCreated={this.onMapCreated}
      >
        {this.renderMarkers()}
        {this.renderInfoWindow()}
      </GMap>
    );
  }
}

MapContainer.propTypes = {
  ...GMap.propTypes,
  markers: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      latitude: PropTypes.number,
      longitude: PropTypes.number,
    }),
  ),
};

export default MapContainer;
